import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type ModalState = 'hidden' | 'select_invoice' | 'save_invoice';

interface ModalInvoiceState {
  modalState: ModalState;
}

const initialState = {
  modalState: 'hidden',
} as ModalInvoiceState;

const modalInvoiceSlice = createSlice({
  name: 'modalInvoice',
  initialState,
  reducers: {
    setModalState: (
      state,
      { payload: { modalState } }: PayloadAction<{ modalState: ModalState }>
    ) => {
      state.modalState = modalState;
    },
  },
});

export const { setModalState: setModalInvoiceState } =
  modalInvoiceSlice.actions;

export default modalInvoiceSlice.reducer;
